const pageTypes = [
  {value: 'evenement', text: 'Page Événements'},
  {value: 'shop', text: 'Page Enseigne'},
  {value: 'confidential', text: 'Page Confidentialité'},
  {value: 'legal_mentions', text: 'Mentions légales'},
  {value: 'office', text: 'Page Bureaux'},
  {value: 'question', text: 'Page FAQ'},
  {value: 'partners', text: 'Page Partenaires'},
  {value: 'offers', text: 'Page Offres'}
]

export const getPageTypeLabel = (type) => {
  for (let page of pageTypes) {
    if (page.value === type) {
      return page.text
    }
  }
}

export const getPageTypes = () => {
  return pageTypes
}



// WEBPACK FOOTER //
// ./src/helpers/pageType.js